const root = '/checkout';

const checkoutRoutes = [
  {
    path: `${root}/top-up-complete`,
    name: 'checkoutTopUpComplete',
    component: () => import('./topUpComplete.vue'),
    meta: {
      title: 'Top-up Successful',
      hideFooter: true,
    },
  },
  {
    path: `${root}/extra-complete`,
    name: 'checkoutExtraComplete',
    component: () => import('./extraComplete.vue'),
    meta: {
      title: 'Purchase Successful',
      requiresAuth: true,
      hideFooter: true,
    },
  },
  {
    path: `${root}/purchase-complete`,
    name: 'checkoutPurchaseComplete',
    component: () => import('./purchaseComplete.vue'),
    meta: {
      title: 'Voucher Purchase Successful',
      hideFooter: true,
    },
  },
  {
    path: `${root}/transfer/:type`,
    name: 'checkoutTransfer',
    component: () => import('@/app/renew/transfer2.vue'),
    meta: {
      title: 'Transfer Home Club',
      requiresAuth: true,
      isWindowView: true,
      windowViewTitle: 'Transfer Home Club',
      hideFooter: true,
    },
  },
  {
    path: `${root}/join/:clubId`,
    name: 'checkoutJoin',
    component: () => import('./join.vue'),
    meta: {
      title: 'Become a PlayMoreGolf Member',
      windowViewTitle: 'Become a PlayMoreGolf Member',
      isWindowView: true,
      requiresAuth: true,
      hideFooter: true,
      noLayout: true,
    },
  },
  {
    path: `${root}/renew`,
    name: 'checkoutRenew',
    component: () => import('./renew.vue'),
    meta: {
      title: 'Renew your Membership',
      windowViewTitle: 'Renew your Membership',
      isWindowView: true,
      requiresAuth: true,
      hideFooter: true,
    },
  },
  {
    path: `${root}/basket`,
    name: 'checkoutBasket',
    component: () => import('./basket.vue'),
    meta: {
      title: 'Your Basket',
      windowViewTitle: 'Your Basket',
      isWindowView: true,
      requiresAuth: true,
      hideFooter: true,
    },
  },
  {
    path: `${root}/summary/:type`,
    name: 'checkoutSummary',
    component: () => import('./summary.vue'),
    meta: {
      title: 'Summary',
      windowViewTitle: 'Summary',
      isWindowView: true,
      requiresAuth: true,
      hideFooter: true,
    },
  },
  {
    path: `${root}/pay`,
    name: 'checkoutPay',
    component: () => import('./pay.vue'),
    meta: {
      title: 'Payment',
      windowViewTitle: 'Payment',
      isWindowView: true,
      requiresAuth: true,
      hideFooter: true,
    },
  },
  {
    path: `${root}/paymonthlygolf`,
    name: 'checkoutPayMonthly',
    component: () => import('./paymonthlygolf.vue'),
    meta: {
      title: 'PayMonthlyGolf',
      windowViewTitle: 'PayMonthlyGolf',
      isWindowView: true,
      requiresAuth: true,
      hideFooter: true,
    },
  },
  {
    path: `${root}/redeem/:type/:code`,
    component: () => import('./redeem.vue'),
    name: 'checkoutRedeem',
    meta: {
      title: 'Redeem',
      requiresAuth: false,
      windowViewTitle: 'Redeem',
    },
  },
  {
    path: `${root}/redeem`,
    component: () => import('./redeemAuthed.vue'),
    name: 'checkoutRedeemAuthed',
    meta: {
      title: 'Redeem',
      requiresAuth: true,
      windowViewTitle: 'Redeem',
    },
  },
];

export default checkoutRoutes;
